"use client";

import { Authenticator } from "@aws-amplify/ui-react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function LoginPage() {
  const router = useRouter();
  return (
    <main className="flex flex-1 flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-xl bg-zinc-900 text-white shadow-md">
            <span className="text-[14px] font-bold">M</span>
          </div>
          <h1 className="mt-3 text-[20px] font-semibold tracking-tight text-zinc-900">
            Mock API Studio
          </h1>
          <p className="mt-1 text-[13px] text-zinc-500">
            Sign in with your company email to continue.
          </p>
        </div>
        <Authenticator signUpAttributes={["email"]}>
          {({ user }) => <SignedIn user={user} onSignedIn={() => router.replace("/projects")} />}
        </Authenticator>
      </div>
    </main>
  );
}

function SignedIn({
  user,
  onSignedIn,
}: {
  user: unknown;
  onSignedIn: () => void;
}) {
  useEffect(() => {
    if (user) onSignedIn();
  }, [user, onSignedIn]);
  return <p className="text-center text-[13px] text-zinc-500">Redirecting…</p>;
}
